import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Caché de datos en cliente: al volver a una vista dentro de staleTime, sirve
// los datos cacheados al instante (sin red); gcTime los retiene tras desmontar.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,        // 1 min "fresco": volver dentro de este lapso = sin refetch
      gcTime: 10 * 60 * 1000,      // conserva el caché 10 min tras desmontar la vista
      refetchOnWindowFocus: false, // no recargar solo por cambiar de pestaña
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
        <Toaster position="top-right" richColors expand={false} />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);